import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { provideAuth } from '@/composables/useAuth'
import { initTheme } from '@/composables/useTheme'
import { initFontSize } from '@/composables/useFontSize'
import { setupPermissionDirective } from '@/directives/permission'
import { initPermissionGuard } from '@/services/permissionGuard'
// Element Plus 全局基础样式：ElMessage/ElMessageBox 等 script 内显式 import 的 API
// 不会触发按需样式注入（unplugin 只覆盖模板组件），必须全局引入，否则全站 toast/确认框无样式不可见
import 'element-plus/dist/index.css'
import './style.css'
import './styles/permission.css'

// Initialize theme and font size before app mount
initTheme()
initFontSize()

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
provideAuth(app)

// Register v-permission directive
setupPermissionDirective(app)

// Initialize permission guard — 仅已登录时加载，未登录访问公开页不触发 401
const authToken = localStorage.getItem('auth_token')
if (authToken) {
  initPermissionGuard()
}

app.use(router)

// ─── Sentry 错误监控 ───────────────────────────────────────────────
// 仅当配置了 VITE_SENTRY_DSN 时启用（.env.example 中有占位符）
// 使用动态 import() 实现条件加载，避免 dev 环境下加载 Sentry 代码
const sentryDsn = import.meta.env.VITE_SENTRY_DSN
if (sentryDsn) {
  import('@sentry/vue').then(({ init, browserTracingIntegration, createSentryPiniaPlugin }) => {
    init({
      dsn: sentryDsn,
      app,
      environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || (import.meta.env.PROD ? 'production' : 'development'),
      integrations: [
        browserTracingIntegration({ router }),
      ],
      // 生产环境采样 10% 的追踪事件
      tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
      // 忽略 Vite 开发服务器的 HMR WebSocket 错误
      ignoreErrors: ['WebSocket', 'Failed to fetch', 'HMR'],
    })

    // 将 Sentry Pinia 插件注册到 pinia store
    pinia.use(createSentryPiniaPlugin())
  }).catch(err => {
    // 如果 Sentry 包加载失败（例如未安装），静默忽略
    console.warn('[Sentry] Failed to initialize:', err)
  })
}
// ───────────────────────────────────────────────────────────────────

app.mount('#app')
